export default __webpack_public_path__ + "static/font-7cf89b4a0822ebbbf0a762fb9d90fcc6.eot";